export const Stats = (props) => {
  return (
    <div>
      Stats
    </div>
  )
}